import { Grid, TextField, Tooltip, Box } from '@mui/material'
import { useCallback, useEffect } from 'react'
import { metodoPrograma } from '../../../../components/api'
import PrimeTable from '../../../../components/PrimeTable'
import NumberSpinner from '../../../financeiro/pontoDeVenda/qunatidadeProdutoTable'

export const TerapiaAgendamento = ({
  idAgendamento,
  disabilitado = false,
  listaTerapia,
  setListaTerapia,
}) => {
  const getLista = useCallback(() => {
    metodoPrograma('listaTerapia', {
      idAgendamento,
    }).then((response) => {
      if (response.status) {
        setListaTerapia(response.lista)
      }
    })
  }, [idAgendamento, setListaTerapia])

  useEffect(() => {
    getLista()
  }, [getLista])

  const trataQuantidadeLinha = (linha) => (quantidade) => {
    setListaTerapia((prev) =>
      prev.map((item) => {
        if (item[0] === linha[0]) {
          const novaLinha = [...item]
          novaLinha[6] = quantidade
          return novaLinha
        }
        return item
      }),
    )
  }

  const trataObservacaoLinha = (linha) => (event) => {
    const novaObs = event.target.value
    setListaTerapia((prev) =>
      prev.map((item) => {
        if (item[0] === linha[0]) {
          const novaLinha = [...item]
          novaLinha[7] = novaObs
          return novaLinha
        }
        return item
      }),
    )
  }

  return (
    <Grid item xs={12}>
      <PrimeTable
        dadosTable={listaTerapia}
        disablePagination
        head={['Terapia', 'Solicitou', 'Observações', 'Aceitou']}
        colStyle={[{ width: '65%' }]}
        rowHighlight={(row) => (row[8] == null ? false : row[6] > row[8])}
        line={(item) => [item?.[1], 0]}
        columnOptions={[
          {
            alias: 0,
            customJsx: ({ linhaOriginal }) => (
              <Grid container>
                <Grid item xs={12}>
                  <Tooltip title={linhaOriginal?.[1]}>
                    <span
                      style={{
                        fontSize: '2.0vh',
                        fontWeight: 370,
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        display: 'block',
                      }}
                    >
                      {linhaOriginal?.[1]}
                    </span>
                  </Tooltip>
                </Grid>
              </Grid>
            ),
          },
          {
            alias: 1,
            customJsx: ({ linhaOriginal }) => (
              <Box
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                }}
              >
                <NumberSpinner
                  size="small"
                  disabled={disabilitado}
                  onChange={trataQuantidadeLinha(linhaOriginal)}
                  value={linhaOriginal?.[6]}
                  min={0}
                />
              </Box>
            ),
          },
          {
            alias: 2,
            customJsx: ({ linhaOriginal }) => (
              <>
                {linhaOriginal?.[6] > 0 && (
                  <TextField
                    fullWidth
                    variant="outlined"
                    margin="dense"
                    size="small"
                    disabled={disabilitado}
                    value={linhaOriginal?.[7] || ''}
                    onChange={trataObservacaoLinha(linhaOriginal)}
                    placeholder="..."
                  />
                )}
              </>
            ),
          },
          {
            alias: 3,
            customJsx: ({ linhaOriginal }) => <>{linhaOriginal[8]}</>,
          },
        ]}
      />
    </Grid>
  )
}
